import { UUID } from '../../model/uuid';
import { TaggingAnnotationScheme } from '../../annotation/scheme';
import { EntityMentionAnnotationScheme } from '../../annotation/scheme';
import { SituationMentionAnnotationScheme } from '../../annotation/scheme';
import { Type } from '../../annotation/ontology';
import { Dropdown } from 'react-bootstrap';
import { DropdownButton } from 'react-bootstrap';
import { ButtonGroup } from 'react-bootstrap';
import { EntityAnnotationScheme } from '../../annotation/scheme';
import { SituationAnnotationScheme } from '../../annotation/scheme';

type MentionAnnotationScheme = EntityMentionAnnotationScheme
                               | SituationMentionAnnotationScheme;

type ReferentAnnotationScheme = EntityAnnotationScheme
                               | SituationAnnotationScheme

interface TagProps {
    annotationScheme: TaggingAnnotationScheme | MentionAnnotationScheme | ReferentAnnotationScheme;
    activeTypeId: UUID | null;
    value: string;
    onSelect: (typeId: UUID) => void;
}

export function Tag(props: TagProps) {
    let currTag = '';

    if (props.value !== undefined) {
        currTag = props.value;
    }

    const items = props.annotationScheme.ontology.types.map(
        (t: Type, i: number) => 
            <Dropdown.Item 
             key={ t.value+i } 
             href={"#/action-" + i}
             onSelect={() => props.onSelect(t.uuid)}
            >
                { t.value }
            </Dropdown.Item>
    );

    const activeType = props.annotationScheme.ontology.types.find(
        t => t.uuid.uuidString === props.activeTypeId?.uuidString
    );
    const typeIsActive = (
        props.value === activeType?.value
    );
    const tagClassName = typeIsActive 
                         ? "primary" 
                         : "secondary";
    if(props.annotationScheme.kind === 'referent'){
        return null;
    }
    return (
        <DropdownButton 
            as={ButtonGroup} 
            id="dropdown-basic-button" 
            size="sm" 
            variant={ tagClassName }
            title={ currTag }>
            {items}
        </DropdownButton>
    );
}